module.exports = __webpack_public_path__ + "img/referra-dark-logo-433x100.3ff0852a.png";